import { render, staticRenderFns } from "./FullNameCell.vue?vue&type=template&id=4f71d6ec&"
import script from "./FullNameCell.vue?vue&type=script&lang=js&"
export * from "./FullNameCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports